import { useVisualComponentsContext } from '../../contexts';

type EditReadInputProps = {
  value: boolean;
  onChange: (newValue: boolean) => void;
};

export const EditReadInput = ({ value, onChange }: EditReadInputProps) => {
  const { EditReadSelect: VisualComponent } = useVisualComponentsContext();

  return <VisualComponent value={value} onChange={onChange} isDisabled={false} hasError={false} />;
};
